<section class="addUser w-full max-w-2xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">מתפללים</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
  </header>

  <form
    novalidate
    [formGroup]="addUserForm"
    (ngSubmit)="onSubmit()"
    class="card-2026 space-y-5"
    autocomplete="off"
  >
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-row-2026">
        <label class="form-row-2026__label" for="addUserFirstName">שם פרטי</label>
        <input
          id="addUserFirstName"
          type="text"
          placeholder="ישראל"
          class="input-2026"
          formControlName="firstName"
          name="firstName"
          autocomplete="given-name"
        />
      </div>
      <div class="form-row-2026">
        <label class="form-row-2026__label" for="addUserLastName">שם משפחה</label>
        <input
          id="addUserLastName"
          type="text"
          placeholder="ישראלי"
          class="input-2026"
          formControlName="lastName"
          name="lastName"
          autocomplete="family-name"
        />
      </div>
    </div>

    <div class="form-row-2026">
      <label class="form-row-2026__label" for="addUserEmail">אימייל</label>
      <input
        id="addUserEmail"
        type="email"
        inputmode="email"
        placeholder="user@example.com"
        class="input-2026"
        formControlName="email"
        name="email"
        autocomplete="email"
      />
    </div>

    <div class="form-row-2026">
      <label class="form-row-2026__label" for="addUserPassword">סיסמה</label>
      <input
        id="addUserPassword"
        type="password"
        class="input-2026"
        formControlName="password"
        name="password"
        autocomplete="new-password"
      />
      <small class="form-row-2026__hint">תהיה ניתנת לשינוי בהמשך.</small>
    </div>

    <div class="form-row-2026">
      <label class="flex items-start gap-3 cursor-pointer p-3 rounded-lg border border-ink-100 hover:bg-bg transition-colors min-h-tap">
        <input
          type="checkbox"
          formControlName="hasAccess"
          name="hasAccess"
          class="mt-1 w-5 h-5 accent-primary-500"
        />
        <span class="flex flex-col">
          <span class="text-base font-medium text-ink-800">{{ hasAceessLabel }}</span>
          <span class="text-sm text-ink-500">סמן במידה והמשתמש הינו חבר ועד</span>
        </span>
      </label>
    </div>

    <div class="pt-2 flex justify-end">
      <button
        type="submit"
        class="btn-2026--primary w-full md:w-auto md:min-w-[200px]"
        [disabled]="loading || addUserForm.invalid"
      >
        <span *ngIf="!loading" class="flex items-center gap-2">
          <i class="material-symbols-outlined" aria-hidden="true">person_add</i>
          הוסף משתמש
        </span>
        <span *ngIf="loading" class="flex items-center gap-2">
          <mat-spinner diameter="22"></mat-spinner>
          <span>שומר...</span>
        </span>
      </button>
    </div>
  </form>
</section>
